const topics = [
  { id: 1, name: '顶流塌房', count: '128万讨论', hot: true },
  { id: 2, name: '综艺黑幕', count: '96万讨论', hot: true },
  { id: 3, name: '网红翻车', count: '85万讨论', hot: true },
  { id: 4, name: '明星恋情', count: '73万讨论', hot: false },
  { id: 5, name: '娱乐圈资本', count: '68万讨论', hot: false },
  { id: 6, name: '影视剧瓜', count: '62万讨论', hot: false },
  { id: 7, name: '音乐圈内幕', count: '55万讨论', hot: false },
  { id: 8, name: '直播带货', count: '48万讨论', hot: false },
  { id: 9, name: '经纪公司', count: '42万讨论', hot: false },
  { id: 10, name: '选秀争议', count: '37万讨论', hot: false },
  { id: 11, name: '社会话题', count: '31万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">热门话题</h2>
          <p className="text-foreground-500 text-sm">大家都在讨论什么？点击话题加入吃瓜大军</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((t) => (
            <a
              key={t.id}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-200 cursor-pointer whitespace-nowrap ${
                t.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200/70 text-foreground-600 hover:border-foreground-300'
              }`}
            >
              {t.hot && <i className="ri-fire-line text-sm"></i>}
              <span className="text-sm font-medium">{t.name}</span>
              <span className={`text-xs ${t.hot ? 'text-primary-400' : 'text-foreground-400'}`}>{t.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}